import React from 'react';
import { ButtonProps, Empty, Spin } from 'antd';
import Icon from '@ant-design/icons';

import {
  Body,
  Container,
  EventNameValueWrapper,
  Footer,
  FooterTitle,
  Header,
  Name,
  Value,
} from '@src/emp-3.0/components/MappedEventDetail/styled';
import ViewDetailIcon from '@icons/emp/view_detial.svg';
import { MappingRulesRender } from '@src/emp-3.0/components/MappedEventDetail';
import { useGetMappedEventById } from '@src/emp-3.0/api/queryHooks';

import { StyledAntButton } from './styled';

interface okButtonProps extends Omit<ButtonProps, 'onClick'> {
  onClick?: (value) => void;
}
interface noButtonProps extends Omit<ButtonProps, 'onClick'> {
  onClick?: (value) => void;
}

export interface IMappedEventQuickLook {
  id?: string | number;
  searchText?: string;
  footer?: React.ReactNode;
  okButtonProps?: okButtonProps;
  noButtonProps?: noButtonProps;
}

const MappedEventQuickLook: React.FC<IMappedEventQuickLook> = ({
  id,
  searchText,
  footer,
  okButtonProps,
  noButtonProps,
}) => {
  const { data: mappedEventData, isFetching: isLoadingMappedEventData } = useGetMappedEventById({
    id,
  });
  const mappedEvent = mappedEventData?.data;

  const noDescription = !mappedEvent?.description;
  const noRules = !Array.isArray(mappedEvent?.rules);

  if (!mappedEvent)
    return (
      <Spin spinning={isLoadingMappedEventData}>
        <Empty description="Data Not Found" />
      </Spin>
    );

  const renderFooter = () => {
    return null;
    if (footer === null) {
      return null;
    }

    if (footer === undefined) {
      return (
        <Footer>
          <FooterTitle>Would you like to edit the mapping rules?</FooterTitle>
          <StyledAntButton
            type="link"
            {...okButtonProps}
            onClick={() =>
              okButtonProps?.onClick?.({
                ...mappedEvent,
                event_name: `${mappedEvent?.event_name}_copy`,
              })
            }
          >
            Yes, clone and edit
          </StyledAntButton>
          <StyledAntButton
            type="link"
            {...noButtonProps}
            onClick={() => noButtonProps?.onClick?.(id)}
          >
            No, use directly
          </StyledAntButton>
        </Footer>
      );
    }

    return footer;
  };

  return (
    <Container
      onClick={(e) => {
        e.stopPropagation();
      }}
      style={noDescription && noRules ? { padding: 0, width: 'auto' } : undefined}
    >
      <Body style={{ padding: '8px 16px' }}>
        {!noDescription && (
          <div style={{ marginBottom: '8px' }}>
            <EventNameValueWrapper>
              <Name style={{ color: 'rgba(0, 0, 0, 0.45)' }}>Description :</Name>
              <Value>{mappedEvent?.description}</Value>
            </EventNameValueWrapper>
          </div>
        )}
        {noRules ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            This is a pre-defined event mapped from Conviva.
          </div>
        ) : (
          <MappingRulesRender rules={mappedEvent?.rules} searchText={searchText} />
        )}
      </Body>
      {renderFooter()}
    </Container>
  );
};

export default MappedEventQuickLook;
